import { generateActions } from '../utils';
import { API_CONST } from '../middlewares/api';
import { handleActions, createAction } from 'redux-actions';

const initial = {
    items: {},
}

const getVisits = generateActions('personVisits/info/GET_INFO')

//получение списка встреч персоны
export const getAllVisits = createAction(
    API_CONST,
    () => ({
      url: `auth/person/visits`,
      actions: getVisits,
    })
)

export default handleActions({
  [getVisits[0]]: state => ({ ...initial }),
  [getVisits[1]]: (state, { payload = {} }) => ({ ...state, items: { ...state.items, ...payload } }),
}, initial)


// WEBPACK FOOTER //
// ./src/store/reducers/visitsOfPerson.js